export enum HelpUrl {
    menuOrder = 'orders',
    menuCatalog = 'catalog',
    menuLocation = 'locations',
    menuSettings = 'store-settings',
    menuStatistics = 'statistics',
    menuUser = 'users',
    menuSubscription = 'subscription',
    menuCustomers = 'customers',
    menuBilling = 'subscription',
    menuPartner = 'partner',
    menuRegisterStore = 'register',
    menuSharePreview = 'share',
    menuCatalogOffer = 'catalog/manage-offer',
    menuCatalogOptionGroup = 'catalog/option-groups',
    menuCatalogPriceVariants = 'catalog/price-variants',
    menuCatalogCategory = 'catalog/manage-categories-2',
    menuManageByExcel = 'catalog/manage-catalog-via-excel',
    menuCatalogOptionsByExcel = 'catalog/manage-catalog-options-via-excel',
    menucatalogChangeAndTranslateLable = 'catalog/translations-2/#Change-and-Translate-Labels',
    menucatalogImportFromPhoto = 'catalog/import-catalog-from-photo/',
    menuSettingsStoreDetails = 'store-settings/store-details',
    menuSettingsStoreOrdering = 'store-settings/order-settings/order-capture/',
    menuSettingsMultipleStore = 'store-settings/link-multiple-stores/',
    menuSettingsStorePayment = 'store-settings/payment-settings',
    menuSettingsStorePickup = 'store-settings/pickup-delivery-settings',
    menuSettingsStoreDelivery = 'store-settings/pickup-delivery-settings/#delivery-fee-order-min-amount',
    menuSettingsAddZones = 'store-settings/pickup-delivery-settings/#delivery-fee-order-min-amount',
    menuSettingsStoreLocations = 'store-settings/define-mandatory-or-optional-fields-in-customer-information/#customer-information-for-table-service',
    menuReservations = 'manage-table-reservations/',
    menuSettingsReservations = 'manage-table-reservations/',
    menuSettingsStoreCatalog = 'store-settings/change-the-catalog-settings',
    menuSettingsStoreOrderingRule = 'store-settings/manage-ordering-rules',
    menuSettingsStoreSchedules = 'store-settings/manage-store-schedules',
    menuSettingsStoreMarketing = 'store-settings/connect-to-your-marketing-tools',
    menuSettingsStoreDiscountVouchers = 'store-settings/manage-discount-vouchers',
    menuSettingsStoreDomainsAndApps = 'store-settings/use-gonnaorder-with-a-custom-domain/',
    menuSettingsStoreIntegrations = 'store-settings/integrations/',
    menuSettingsStoreBranding = 'store-settings/branding/',
    menuSettingsStoreLoyalty = 'store-settings/loyalty/',
    enableCustomerAuthentication = 'store-settings/order-settings/order-capture/#activate-customer-authentication',
    displayPickupAddress = 'store-settings/pickup-delivery-settings/#hide-or-show-pickup-address/',
    delieveryZoneRestriction = 'store-settings/pickup-delivery-settings/#enable-delivery-zone-restrictions',
    openTabOrdering = 'store-settings/enable-and-manage-open-tab-table-ordering/',
    requestOrderDateUpfront = 'store-settings/configure-additional-settings-for-orders-and-schedules/#request-order-date-upfront',
    maximumItemsPerSlot = 'store-settings/configure-additional-settings-for-orders-and-schedules/#maximum-items-per-slot',
    requestDesiredTime = 'store-settings/configure-additional-settings-for-orders-and-schedules/#request-order-desired-time-in-future',
    DesiredTimeInMinutes = 'store-settings/configure-additional-settings-for-orders-and-schedules/#wish-time-intervals',
    SlotDurationInMinutes = 'store-settings/configure-additional-settings-for-orders-and-schedules/#slot-duration',
    defaultOrderingMode = 'store-settings/configure-additional-settings-for-orders-and-schedules/#default-ordering-mode',
    apps = 'store-settings/promote-ordering-with-gonnaorder-mobile-apps/',
    mynext = 'store-settings/integrations/last-mile-delivery/',
    wooDelivery = 'store-settings/integrations/woo-delivery',
    hubrise = 'store-settings/integrations/hubrise-integration',
    powersoft = 'store-settings/integrations/powersoft-pos-integration/',
    eposDirect = 'store-settings/integrations/eposdirect',
    poster = 'store-settings/integrations/poster',
    eposNow = 'store-settings/integrations/eposnow',
    jcc = 'store-settings/payment-settings/jcc-payments/',
    payabl = 'store-settings/payment-settings/payabl-payments/',
    stripe = 'store-settings/payment-settings/stripe-payments/',
    rms = 'store-settings/payment-settings/rms-payments/',
    trust = 'store-settings/payment-settings/use-trust-payments/',
    paymentsense = 'store-settings/payment-settings/use-paymentsense-as-payment-provider/',
    vivawallet = 'store-settings/payment-settings/viva/',
    square = 'store-settings/payment-settings/square-payments/',
    paypal = 'store-settings/payment-settings/paypal-me/',
    other = 'store-settings/payment-settings/other-payment-providers/',
    globalpay = 'store-settings/payment-settings/globalpay-payments/',
    mollie = 'store-settings/payment-settings/mollie-payments/',
    fygaro = 'store-settings/payment-settings/fygaro-payments/',
    apcopay = 'store-settings/payment-settings/apcopay-payments/',
    epay = 'store-settings/payment-settings/epay-payments/',
    hobex = 'store-settings/payment-settings/hobex-payments/',
    ryft = 'store-settings/payment-settings/ryft-payments/',
    abapayway = 'store-settings/payment-settings/abapayway-payments/',
    rootline = 'store-settings/payment-settings/rootline-payments/',
    solidgate = 'store-settings/payment-settings/solidgate-payments/',
    emerchantpay = 'store-settings/payment-settings/emerchantpay-payments/',
    neosoft = 'store-settings/payment-settings/neosoft-payments/',
    countAgainstSlotCount = 'store-settings/configure-additional-settings-for-orders-and-schedules/#maximum-items-per-slot/',
    optiongroup = 'catalog/option-groups/',
    allowordering = 'share/#download-read-only-menu-QR-code',
    paymentOptions = 'store-settings/payment-settings/payment-options/',
    standalonePayments = 'standalone-payments/',
    openTableOnAdminOrder = 'store-settings/table-ordering-settings/#open-table-on-admin-order',
    manageStock = 'catalog/setup-stock-features/',
    addOptionGroup = 'store-settings/manage-ordering-rules/#add-option-groups-and-options-to-your-rules-actions',
    facebookPixel = 'store-settings/connect-to-your-marketing-tools/#connecting-your-store-to-facebook-pixel',
    googleAnalytics = 'store-settings/connect-to-your-marketing-tools/#connecting-your-gonnaorder-store-to-google-analytics',
    flexDelivery = 'store-settings/integrations/flex-delivery/',
    shopify = 'store-settings/integrations/shopify-integration/',
    customIntegration = 'store-settings/integrations/publish-orders-with-custom-integration/',
    inheritParentStoreCatalog = 'store-settings/link-multiple-stores/#inherit-parent-store-catalog',
    inheritCatalog = 'store-settings/link-multiple-stores/#inherit-parent-store-catalog',
    inheritSchedules = 'store-settings/link-multiple-stores/#inherit-schedules-from-parent-store',
    menuStandalonePayment = 'standalone-payments/view-customer-payments/',
    paymentRequests = 'standalone-payments/custom-payment-requests/',
    menuSettingsStoreOrderManagement = 'store-settings/order-settings/order-management/',
    sunSoft = 'store-settings/integrations/connect-with-sunsoft/',
    hit = 'store-settings/integrations/hit',
    googleTagManager = 'store-settings/connect-to-your-marketing-tools/#connecting-your-store-to-google-tag-manager/',
    twinSoft = 'store-settings/integrations/connect-with-twinsoft/',
    tableManageByExcel = '',
    wolt='catalog/import-catalog-from-wolt/',
    orderFulfilment= 'store-settings/order-settings/select-order-fulfilment-method/',
    MemberAuthentication = 'store-settings/order-settings/order-capture/#member-only-authentication',
    ClearBasketInactivity = 'store-settings/order-settings/order-capture/#clear-basket-and-order-on-inactivity',
    TermsConditionsAcceptance = 'store-settings/order-settings/order-capture/#terms-and-conditions-acceptance',
    EnableBillingAddress = 'store-settings/order-settings/order-capture/#enable-billing-address',
    BuzzerNumber = 'store-settings/order-settings/order-capture/#buzzer-number',
    TimeRangeMinutes = 'store-settings/order-settings/order-management/#set-order-processing-time',
    AllowOrderStore = 'orders/update-submitted-orders/#enable-order-update-setting',
    AllowOrderDeletion = 'orders/delete-orders/',
    DetailedOrderReceipt = 'store-settings/order-settings/order-management/#Detailed-Order',
    AutomaticallyAcceptOrders = 'store-settings/order-settings/order-management/#automatically-accept-orders',
    PayLaterOption = 'store-settings/payment-settings/payment-options/#set-preferred-pay-later-option',
    AllowCustomerReservations = 'store-settings/change-table-reservation-settings/#allow-customer-reservations',
    DefaultReservationDduration = 'store-settings/change-table-reservation-settings/#set-default-reservation-time',
    ReservationSchedule = 'store-settings/change-table-reservation-settings/#schedule-reservations',
    CustomerReservationSchedule = 'store-settings/change-table-reservation-settings/#schedule-customer-reservations',
    DesiredTimeIntervals = 'store-settings/change-table-reservation-settings/#set-reservation-intervals',
    ServiceCharge = 'store-settings/table-ordering-settings/#location-service-charge',
    LocationType = 'store-settings/table-ordering-settings/#define-default-location-type',
    DefaultCatalogView = 'store-settings/change-the-catalog-settings/#collapse-default-view',
    SameDayOrdering = 'store-settings/configure-additional-settings-for-orders-and-schedules/#same-day-ordering',
    OrdersPerSlot = 'store-settings/configure-additional-settings-for-orders-and-schedules/#orders-per-slot',
    DisplayDesiredDate = 'store-settings/configure-additional-settings-for-orders-and-schedules/#display-or-hide-order-desired-time',
    DesiredDateTime = 'store-settings/manage-store-schedules/#wish-date-at-order-level',
    Domains = 'store-settings/use-gonnaorder-with-a-custom-domain/#change-or-update-gonnaorder-domain',
    NewUserDiscount = 'store-settings/loyalty/#activate-new-user-discount',
    iotsoftIntegration = 'store-settings/integrations/iotsoft-integration/',
    witecIntegration = 'store-settings/integrations/witec-integration/'

}
